export const motion = {
  transitions: {
    emphasis: "transition-colors duration-240 ease-out",
    subtle: "transition-opacity duration-240 ease-in-out",
    layout: "transition-all duration-240 ease-out",
  },
  focus: {
    ring: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
  },
  animations: {
    pulse: "sb-animate-beacon",
    beacon: "sb-animate-beacon",
    shimmer: "animate-shimmer",  // 2s canonical (CANON v1.3.0 Design Canon 5.4)
    spin: "animate-spin",
  },
};
